<template>
    <div class="data-page data-stack">

        <Summary />

    </div>
</template>

<script>

import Summary from './Summary.vue'

export default {
    components: {
        Summary
    },
}
</script>
